import { ThemeProvider } from "@material-ui/core";
import { StylesProvider } from "@material-ui/core/styles";

import { Provider as FormProvider } from "./components/Provider";
import { theme } from "./theme/mui";

export const App = (): JSX.Element => (
  <ThemeProvider theme={theme}>
    <StylesProvider injectFirst>
      <FormProvider />
    </StylesProvider>
  </ThemeProvider>
);
